// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"b412af47","289":"abe65edb","473":"e2058c49","591":"0897bb2e"}[chunkId] + ".chunk.css";
};